// import axios, { AxiosError } from "axios";
import axios, { AxiosError } from "axios";
import { setToggaleLoginModal } from "storeRedux/slices/authSlice";
import { store } from "storeRedux/store";



export interface AsyncProcessErrorProps{
    error:string,words?:ObjectType<string>,severity?:string
}


type fun = ( value?:any ) =>void

interface GetAsyncProcessProps{
    type?:"get",
    data?:{
        params:ObjectType<any>
    }
}

interface OtherAsyncProcessProps{
    type?:"post"|"put"|"delete",
    data?:ObjectType<any>|FormData
}


export interface AsyncProcessProps{
    // type?:"get"|"post"|"put"|"delete"
    url?:string,
    // data?:ObjectType<any>|FormData,
    code?:200|201|202|203|204,
    headers?:{
        "Content-Type"?:"application/json"|"multipart/form-data",
        "X-HTTP-Method-Override"?:"PUT"|"DELETE"
    },
    setError?:(value:AsyncProcessErrorProps|null)=>void
    effectProcess?:fun[]
}



export const AsyncProcess= async ({
    type="get",
    url="",
    data={},
    code=200,
    headers={'Content-Type':'application/json'},
    setError=()=>{},
    ...props
}:AsyncProcessProps&(GetAsyncProcessProps|OtherAsyncProcessProps))=>{


    try {
        const response = await axios[type](url,data,{headers:headers});
        if (response.status === code) {

            props.effectProcess?.forEach(f=>f(response.data));
            return response.data;
        }else {  
            return  {error:"code-error"}
        }
    } catch (err) {

        const axiosError = err as AxiosError;

        if (axiosError.response?.status === 401) {
            store.dispatch(setToggaleLoginModal());
        }
        setError(((((err as AxiosError)?.response?.data as ObjectType<any>)||{error:"no-connect"}) as AsyncProcessErrorProps )||null);
        return "error"
    }

  
   
}